import "./SinglePostTemplate.module.css"
import Header from "@/reusable_sections/Header"
import TravelPost from "./sections/TravelPost"
import Footer from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <Header />
      <TravelPost />
      <Footer />
    </div>
  )
}
